import React, { useState } from 'react';
import Icon from 'icon';
import s from './form-input.module.scss';

export default function FormInput({
  className,
  required,
  textarea,
  type,
  error,
  id,
  white,
  lowOpacity,
  inputRef,
  dark,
  ...props
}) {
  const [status, setStatus] = useState('password');
  const lowOpacityClass = lowOpacity ? s.lowOp : '';
  const darkClass = dark ? s.dark : '';
  const whiteClass = white ? s.white : '';
  const textareaClass = textarea ? s.textarea : '';
  return (
    <div className={`${s.root} ${className || ''} ${textareaClass} ${lowOpacityClass} ${error ? s.error : ''}`}>
      {textarea ? (
        <textarea ref={inputRef} className={whiteClass + darkClass} id={id} {...props} />
      ) : (
        <input
          ref={inputRef}
          id={id}
          type={type === 'password' ? status : type}
          {...props}
          className={`${whiteClass} ${darkClass}`}
        />
      )}
      {type === 'password' && (
        <div
          className={`${s.iconWrapper} ${status === 'password' ? s.lightTextColor : s.textColor}`}
          onMouseDown={() => {
            setStatus('text');
          }}
          onMouseUp={() => {
            setStatus('password');
          }}
          onMouseLeave={() => {
            setStatus('password');
          }}
        >
          <Icon icon="eye" />
        </div>
      )}
    </div>
  );
}
